import Vue from 'vue'
import App from './App.vue'
import { router } from './router.js'
import { store } from './store/store.js'
import i18n from './assets/i18n/i18n'
import vuetify from './vuetify'
import VueFileAgent from 'vue-file-agent'
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'
import alvPlugin from '@/assets/helpers/alvPlugin'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import "./vee-validate.js"
import "./assets/css/style.css"

Vue.use(VueFileAgent);

const plugin = {
  install (Vue, options) {
    Vue.prototype.$alvPlugin = alvPlugin // can be used in components with "this.$alvPlugin" 
  }
}

Vue.use(plugin)

new Vue({
  router,
  store,
  i18n, 
  vuetify,
  render: h => h(App)
}).$mount('#app')

// Only for development mode:
// window['vue'] = app
// window.store = store
Vue.config.productionTip = false
// Vue.config.silent = true